import { buttons } from "@icarros/theme-react";
export const { sizes, types } = buttons;
export var DirectionVariants;
(function (DirectionVariants) {
    DirectionVariants["neutral"] = "neutral";
    DirectionVariants["primary"] = "primary";
    DirectionVariants["secondary"] = "secondary";
})(DirectionVariants || (DirectionVariants = {}));
export var DirectionWeights;
(function (DirectionWeights) {
    DirectionWeights["small"] = "small";
    DirectionWeights["medium"] = "medium";
})(DirectionWeights || (DirectionWeights = {}));
//# sourceMappingURL=constants.js.map